import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return ($options.type_obj)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["source-type", {internal: $props.internal}])
      }, [
        _createVNode(_component_Icon, {
          size: "1.6rem",
          stroke: $options.color,
          icon: $options.icon,
          "stroke-width": "1"
        }, null, 8 /* PROPS */, ["stroke", "icon"]),
        ($props.showTitle)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString($options.title), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}